import { Array } from 'effect'

import type { NodePropertyName } from '../../../../schemas/view_config/index.ts'

export function isSameNodeProperty(
  a: NodePropertyName | undefined,
  b: NodePropertyName | undefined,
  // デフォルトではmodelNameの一致は見ない
  shouldIgnoreModelNameMatch = true,
): boolean {
  if (a === undefined || b === undefined) {
    return false
  }

  const isMatchNodeNameAndPropertyName = b.nodeName === a.nodeName && b.propertyName === a.propertyName

  return shouldIgnoreModelNameMatch
    ? isMatchNodeNameAndPropertyName
    : isMatchNodeNameAndPropertyName && b.modelName === a.modelName
}

const differenceWithNodePropertyName = Array.differenceWith<NodePropertyName>((x, y) => isSameNodeProperty(x, y))

/** NodePropertyName[] の対称差を抽出する */
export const symmetricDifferenceNodeProperties = (
  listA: NodePropertyName[],
  listB: NodePropertyName[],
): NodePropertyName[] => [
  ...differenceWithNodePropertyName(listA, listB),
  ...differenceWithNodePropertyName(listB, listA),
]
